module.exports = __webpack_public_path__ + "img/top_right.bc15aef7.png";